"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isRunningOnLocal = () => location.host === "localhost:3000";
exports.default = isRunningOnLocal;
